import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import BiggestDiscountList from './BiggestDiscountList';
import CommercialBannerList from './CommercialBannerList';
import MostPopularList from './MostPopularList';
import NewestOffersList from './NewestOffersList';
import RecommendedOffersList from './RecommendedOffersList';
import FavouriteBrands from './FavouriteBrands';
import { isUserLoggedIn } from '../utils/auth';
import HomepageSectionsNavigation from './HomepageSectionsNavigation';
import CurrentOffers from './CurrentOffers';
import HomepageSectionContainer from './HomepageSectionContainer';
import YettelAdvantageList from './YettelAdvantageList.tsx';
import AvailableSoonOffersList from './AvailableSoonOffersList.tsx';
import { Link } from 'react-router-dom';
import Button from './Button.tsx';
import { SEARCH_PARAMS_FILTERS } from '../constants/searchParamsFilters.ts';
import { NewsletterButtonAndModal } from './NewsletterModal.tsx';
import Banner from '/banners/y-sve-banner.webp';
import PartnerBanner from '../assets/web-partner-banner.png';
import PartnerBannerMidi from '../assets/partner_banner_800-min.png';
import PartnerBannerMini from '../assets/mobile-partner-banner.png';
import '../scss/homepage.scss';

const HomePage = () => {
  const isLoggedIn = isUserLoggedIn();

  const [activeSection, setActiveSection] = useState('current');

  useEffect(() => {
    const yettelContent = document.querySelector('.yettel-content');
    yettelContent?.classList.add('yettel-content--no-top-padding-mobile');
    return () => {
      yettelContent?.classList.remove('yettel-content--no-top-padding-mobile');
    };
  }, []);

  return (
    <>
      <div className="homepage-container">
        <Helmet>
          <title>Yettel Shopping | Kuponi | Kupuj Najnovije i Uštedi | Najveći Popusti do 70%</title>
        </Helmet>

        <Link to={`/ponude?is_advantage=1`}>
          <div className="banner-container d-flex justify-content-center mt-4 ps-2 pe-2">
            <img src={Banner} />
          </div>
        </Link>
        <RecommendedOffersList />

        {isLoggedIn && <FavouriteBrands />}

        <HomepageSectionContainer className="sections-navigation-container">
          <HomepageSectionsNavigation setActiveSection={setActiveSection} activeSection={activeSection} />
          {activeSection === 'current' && <CurrentOffers />}
          {activeSection === 'newest' && <NewestOffersList />}
          {activeSection === 'discount' && <BiggestDiscountList />}
          {activeSection === 'popular' && <MostPopularList />}
        </HomepageSectionContainer>

        <YettelAdvantageList />

        <AvailableSoonOffersList />

        <Link to={`/ponude?${SEARCH_PARAMS_FILTERS.NEWEST}=1`}>
          <Button secondary className="text-center">
            Pogledaj sve najnovije ponude
          </Button>
        </Link>

        <CommercialBannerList />
        <NewsletterButtonAndModal />
      </div>
      <div className="text-center">
        <Link to={`https://www.yettel.rs/sr/biznis/loyalty/yettel-shopping/prijava/`}>
          <picture>
            <source media="(max-width: 500px)" srcSet={PartnerBannerMini} />
            <source media="(max-width: 800px)" srcSet={PartnerBannerMidi} />
            <img src={PartnerBanner} alt="Postanite partner" className="partner-banner" />
          </picture>
        </Link>
      </div>
    </>
  );
};

export default HomePage;
